// src/pages/babilonia/auditoria-tracker.js
//
// Registra en la bitácora de auditoría la navegación y el cierre de
// sesión. Los inicios de sesión NO se mandan desde aquí: los registra
// el servidor directo en /financiamiento/login (exitosos y fallidos).
//
// Nunca truena la app: si la API falla, solo se ignora.

const API_BASE_URL = "https://api.checkmark.mx/";
const ACCESS_TOKEN =
  "1MhYphhrGUbgbdRy7cyYFGQlXS7tAi6ooUoptkHQbOm9GcsKiZM7uMF1MERxwMWq30I7Y3";

// Rutas que no vale la pena registrar.
const RUTAS_IGNORADAS = ["/", "/pages/login", "/pages/error"];

let ultimaRutaRegistrada = "";

export const registrarEventoAuditoria = (evento, detalle = "") => {
  try {
    const idUsuario = localStorage.getItem("userId");
    const token = localStorage.getItem("accessToken");

    if (!idUsuario || !token) return;

    fetch(`${API_BASE_URL}financiamiento/auditoria/evento`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      // keepalive permite que la petición termine aunque se cambie de página
      keepalive: true,
      body: JSON.stringify({
        access_token: ACCESS_TOKEN,
        id_usuario: idUsuario,
        evento,
        detalle,
      }),
    }).catch(() => {});
  } catch (error) {
    // Silencioso a propósito
  }
};

export const registrarNavegacionAuditoria = (pathname = "") => {
  const ruta = String(pathname || "").split("?")[0];

  if (!ruta || RUTAS_IGNORADAS.includes(ruta)) return;
  // Evita doble registro por re-render (StrictMode, cambios de estado, etc.)
  if (ruta === ultimaRutaRegistrada) return;

  ultimaRutaRegistrada = ruta;
  registrarEventoAuditoria("navegacion", ruta);
};

export const registrarLogoutAuditoria = () => {
  ultimaRutaRegistrada = "";
  registrarEventoAuditoria("logout");
};
